"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GiveawayToJSON = exports.GiveawayFromJSONTyped = exports.GiveawayFromJSON = exports.instanceOfGiveaway = void 0;
var runtime_1 = require("../runtime");
var GiveawayAction_1 = require("./GiveawayAction");
var GiveawayStatistics_1 = require("./GiveawayStatistics");
var GiveawayStats_1 = require("./GiveawayStats");
var GiveawayStatus_1 = require("./GiveawayStatus");
var GiveawayVoucher_1 = require("./GiveawayVoucher");
/**
 * Check if a given object implements the Giveaway interface.
 */
function instanceOfGiveaway(value) {
    var isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "ownerId" in value;
    isInstance = isInstance && "startDate" in value;
    isInstance = isInstance && "endDate" in value;
    isInstance = isInstance && "actions" in value;
    isInstance = isInstance && "status" in value;
    return isInstance;
}
exports.instanceOfGiveaway = instanceOfGiveaway;
function GiveawayFromJSON(json) {
    return GiveawayFromJSONTyped(json, false);
}
exports.GiveawayFromJSON = GiveawayFromJSON;
function GiveawayFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'ownerId': json['ownerId'],
        'startDate': (new Date(json['startDate'])),
        'endDate': (new Date(json['endDate'])),
        'actions': (json['actions'].map(GiveawayAction_1.GiveawayActionFromJSON)),
        'vouchers': !(0, runtime_1.exists)(json, 'vouchers') ? undefined : (json['vouchers'].map(GiveawayVoucher_1.GiveawayVoucherFromJSON)),
        'statistics': !(0, runtime_1.exists)(json, 'statistics') ? undefined : (0, GiveawayStatistics_1.GiveawayStatisticsFromJSON)(json['statistics']),
        'status': (0, GiveawayStatus_1.GiveawayStatusFromJSON)(json['status']),
        'stats': !(0, runtime_1.exists)(json, 'stats') ? undefined : (0, GiveawayStats_1.GiveawayStatsFromJSON)(json['stats']),
    };
}
exports.GiveawayFromJSONTyped = GiveawayFromJSONTyped;
function GiveawayToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'ownerId': value.ownerId,
        'startDate': (value.startDate.toISOString()),
        'endDate': (value.endDate.toISOString()),
        'actions': (value.actions.map(GiveawayAction_1.GiveawayActionToJSON)),
        'vouchers': value.vouchers === undefined ? undefined : (value.vouchers.map(GiveawayVoucher_1.GiveawayVoucherToJSON)),
        'statistics': (0, GiveawayStatistics_1.GiveawayStatisticsToJSON)(value.statistics),
        'status': (0, GiveawayStatus_1.GiveawayStatusToJSON)(value.status),
        'stats': (0, GiveawayStats_1.GiveawayStatsToJSON)(value.stats),
    };
}
exports.GiveawayToJSON = GiveawayToJSON;
